import { render } from "./createPM.vue?vue&type=template&id=01a12417"
import script from "./createPM.vue?vue&type=script&lang=js"
export * from "./createPM.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__